import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "assets/css/material-dashboard-react.css?v=1.8.0";

ReactDOM.render(<App />, document.getElementById("root"));
